import { SHARE_ALBUM } from '../actionTypes'

export const shareAlbum = (data: object) => ({
  type: SHARE_ALBUM.name,
  api: {
    url: 'albums/share',
    data,
  },
})
